import type { ReactNode } from 'react';

import type { Severity } from '../api/types';

/** One step in a vertical timeline (DetailScreen «хронология»). Ported
 *  from the prototype's ``function TimelineItem`` at lines 6647-6660.
 *
 *  The wrapping ``.timeline`` container is provided by the caller —
 *  this component is just a row. ``type`` keys the dot colour via the
 *  CSS rules in DetailScreen.css (``.timeline-item.{success,info,
 *  warn,error}``). */
export function TimelineItem({
  ts,
  type,
  text,
}: {
  ts: string;
  type: Severity;
  text: ReactNode;
}) {
  return (
    <div className={`timeline-item ${type}`}>
      <div className="marker">
        <div className="dot" />
        <div className="line" />
      </div>
      <div className="body">
        <div className="ts">{ts}</div>
        <div className="text">{text}</div>
      </div>
    </div>
  );
}
